module.exports = __webpack_public_path__ + "img/ys-zd.db85ed61.png";